import { useContext } from "react";
import { useQuery } from "@tanstack/react-query"

import { LanguageContext } from "../i18n/LanguageProvider"
import { fetchCVById } from "../services/utils/fetch"


export const useFetchCVById = ({ id, enabled, callback, onErrorCallback }) => {
  const { language } = useContext(LanguageContext);

  return useQuery({
    queryKey: ["cv", id, language],
    queryFn: () => fetchCVById(id, callback, onErrorCallback),
    enabled,
    staleTime: 3_600_000, // 1 hour
  });
}
